import { useEffect, useRef } from 'react';

/**
 * Move focus to a freshly-mounted element. Use on the heading of each
 * registration step (and any /play state) so screen readers announce the
 * step title and keyboard users start from a predictable anchor.
 *
 * The target element MUST be focusable — give it `tabIndex={-1}` if it
 * isn't naturally focusable (h1/h2/etc. aren't by default).
 *
 * Fires once on mount only — re-focusing on subsequent renders would be a
 * focus-jail. AnimatePresence with mode="wait" unmounts the previous step
 * before mounting the new one, so each step's hook invocation is fresh.
 */
export function useFocusOnMount<T extends HTMLElement>() {
  const ref = useRef<T>(null);
  useEffect(() => {
    ref.current?.focus();
  }, []);
  return ref;
}
